// extracted by mini-css-extract-plugin
export default {"slider":"Slider__slider--ig-pES_I"};